import React from 'react';
import classNames from 'classnames';
import Typography from '@lib/components/Typography/Typography';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import styles from './CompanyPlanView.module.scss';

export interface PlanSectionTitleProps {
  title: React.ReactNode;
  // Sits on the same baseline as the title — an enabled/disabled badge for the
  // feature the section describes.
  chip?: React.ReactNode;
}

/** A section heading inside a plan info list, optionally badged. */
export default function PlanSectionTitle({
  title,
  chip,
}: PlanSectionTitleProps) {
  return (
    <div
      className={classNames(entityViewStyles.infoListTitle, styles.titleRow)}
    >
      <Typography variant="h3">{title}</Typography>
      {chip}
    </div>
  );
}
